export default __webpack_public_path__ + "/dist/images/termcondition-inactive.3f5a1ae1bab22e2065af547ce585b954.svg";